export const LocationDirectionsConstants = {
    GET_LOC_DIRECTIONS: 'GET_LOC_DIRECTIONS',

    GETALL_LOC_DIRECTIONS_REQUEST: 'GETALL_LOC_DIRECTIONS_REQUEST',
    GETALL_LOC_DIRECTIONS_SUCCESS: 'GETALL_LOC_DIRECTIONS_SUCCESS',
    GETALL_LOC_DIRECTIONS_FAILURE: 'GETALL_LOC_DIRECTIONS_FAILURE'
};